import namespace from '../namespace'

export default namespace('modules', {
  getters: [
    'getModules',
    'getModule',
    'getModuleByKey',
    'getEndpointForList',
    'getEndpointForExport',
  ],
  mutations: [
    'setModules',
    'setModule',
  ],
  actions: [
    'setModules',
    'setModule',
  ],
})
